<template>
  <GModal
    v-model="internalOpened"
    class="notas-g-modal"
    noPadding
    width="700"
    :title="modalTitle"
  >
    <TableV
      class="notas-table-v tabela-justificativas"
      :cols="notasCols"
      disablePagination
      height="auto"
      :rows="notas"
    ></TableV>
  </GModal>
</template>

<script>
import TableV from "@/components/table-v";
import GModal from "@/components/g-modal";

const LIMITE_CONTEXTO = 40;

export default {
  name: "ModalNotas",
  components: {
    TableV,
    GModal,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    notas: {
      type: Array,
      default: () => [],
    },
    contexto: {
      type: String,
      default: "",
    },
  },
  computed: {
    internalOpened: {
      get() {
        return this.opened;
      },
      set(val) {
        this.$emit("update:opened", val);
      },
    },
    modalTitle() {
      const base = "Descrições da nota fiscal";
      if (!this.contexto) return base;
      const contexto =
        this.contexto.length > LIMITE_CONTEXTO
          ? this.contexto.slice(0, LIMITE_CONTEXTO).trim() + "…"
          : this.contexto;
      return `${base} — ${contexto}`;
    },
    notasCols: function () {
      const hasQuantidade = this.notas.length > 0 && this.notas[0].quantidade !== undefined;

      const cols = [
        {
          name: "Cód. Lançamento",
          key: "id",
          width: "15%",
        },
        {
          name: "Descrição Original",
          key: "descricao",
          width: hasQuantidade ? "45%" : "60%",
        },
      ];

      if (hasQuantidade) {
        cols.push({
          name: "Quantidade",
          key: "quantidade",
          width: "15%",
        });
      }

      cols.push({
        name: "Valor Total",
        key: "valor",
        currency: true,
        width: "25%",
      });

      return cols;
    },
  },
};
</script>

<style lang="scss" scoped>
.notas-table-v {
  min-width: 500px;

  ::v-deep .v-data-table__wrapper {
    height: unset !important;
  }
}
</style>
